import { Doughnut, getDatasetAtEvent } from 'react-chartjs-2';
import { FC, useRef } from 'react';
import { ChartData, ChartOptions } from 'chart.js';
import { createTooltipLabel } from 'common/helpers/chart-helpers';

// This is partially completed and needs refinement when coming back to it.
export const ChartDoughnut: FC<{
  title: string;
  tooltipFormat: Intl.NumberFormat;
  shouldAnimate: boolean;
  data: ChartData<'doughnut', (number | [number, number] | null)[], unknown>;
}> = ({
  title,
  tooltipFormat,
  shouldAnimate,
  data
}: {
  title: string;
  tooltipFormat: Intl.NumberFormat;
  shouldAnimate: boolean;
  data: ChartData<'doughnut', (number | [number, number] | null)[], unknown>;
}) => {
  const chartRef = useRef<any>();

  const onClick = (e: any) => {
    console.log(getDatasetAtEvent(chartRef.current, e));
  };

  const options: ChartOptions<'doughnut'> = {
    plugins: {
      title: {
        display: title.length > 0,
        text: title,
        align: 'start',
        font: {
          weight: '700',
          size: 14
        }
      },
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxHeight: 8
        }
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            console.log(context);
            return createTooltipLabel(
              context.parsed,
              tooltipFormat,
              context.dataset.label
            );
          }
        }
      }
    },
    responsive: true,
    maintainAspectRatio: false
  };

  (options as any).animation = shouldAnimate;

  return (
    <Doughnut
      ref={chartRef}
      options={options}
      data={data}
      onClick={onClick}
      updateMode="active"
    />
  );
};
